import { Injectable } from '@angular/core';
import { flatten } from '@sama/micro-dash';
import { MessagingService } from '../../../cross-team-shared/messaging/messaging.service';
import { TokenManagementService } from '../../../cross-team-shared/misc-services/token-management.service';
import { AutoQaResourceService } from '../../../shared/resources/auto-qa-resource.service';
import { AnswersByName } from '../../../team-apis/otterdam/answers/answer';
import {
  AutoQaError,
  AutoQaResponse,
} from '../../../team-apis/otterdam/auto-qa-response';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Injectable()
export class AutoQaService {
  constructor(
    private autoQaResourceService: AutoQaResourceService,
    private messagingService: MessagingService,
    private taskWorkspaceStore: TaskWorkspaceStore,
    private tokenManagementService: TokenManagementService,
  ) {}

  async validate(answers: AnswersByName) {
    if (!this.taskWorkspaceStore.state().project.auto_qa_scripts.length) {
      return { blockingErrors: [] };
    }

    const token = await this.tokenManagementService.getToken('auto_qa');

    const project = this.taskWorkspaceStore.state().project;
    const response = await this.autoQaResourceService.validate({
      projectId: project.id,
      task: this.buildTaskContext(answers),
      userId: this.taskWorkspaceStore.state().currentUser.id,
      scripts: project.auto_qa_scripts,
      token,
    });

    const blockingErrors = getBlockingErrors(response);
    if (blockingErrors.length) {
      this.displayBlockingErrors(blockingErrors);
    }

    return { autoQaScriptsAfterValidation: response.scripts, blockingErrors };
  }

  private displayBlockingErrors(blockingErrors: AutoQaError[]) {
    this.messagingService.error(
      'AutoQA Errors:',
      blockingErrors.map((error) => `${error.type}: ${error.message}`),
    );
  }

  private buildTaskContext(answers: AnswersByName) {
    const task = this.taskWorkspaceStore.state().task;
    return {
      id: task.id,
      step_id: this.taskWorkspaceStore.state().stepId,
      round: task.round,
      data: task.data,
      answers,
    };
  }
}

function getBlockingErrors(response: AutoQaResponse) {
  return flatten(
    response.scripts
      .filter((script) => script.mode === 'production')
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
      .map((script) => script.errors || []),
  );
}
